import React, { useMemo } from 'react';
import { Table, Typography } from 'antd';
import moment from 'moment';

import config from '../../config.json';
import { numberFormat } from './../../utils/numberFormat';
import { clientFullName } from './../../utils/client';

const { Text } = Typography;

const TableSummary = ({ data }) => {
    return (
        <Table.Summary.Row>
            <Table.Summary.Cell>Total</Table.Summary.Cell>
            <Table.Summary.Cell colSpan={5}>
                <Text type="primary">{numberFormat(data.reduce((acc, { value }) => acc + value, 0))}</Text>
            </Table.Summary.Cell>
        </Table.Summary.Row>
    );
}

const SatReportTable = ({ dataSource, loading, rptDetalle }) => {
    const commonCols = [
        {
            title: '# Ticket',
            dataIndex: 'ticketNumber',
            width: 120
        },
        {
            title: 'Importe',
            dataIndex: 'value',
            width: 180,
            render: value => numberFormat(value)
        },
        {
            title: 'Fecha',
            dataIndex: 'date',
            width: 180,
            render: date => moment(date).format(config.dateTimeFormat)
        },
        {
            title: 'Cliente',
            render: value => clientFullName(value.client)
        }
    ];

    const allColumns = [
        ...commonCols,
        { title: 'Plan', dataIndex: 'plan' },
        { title: 'Texto', dataIndex: 'text' },
        { title: 'Oficina', dataIndex: 'oficina' }
    ];

    const columns = useMemo(() => rptDetalle ? allColumns : commonCols, [rptDetalle]);

    return <Table
        {...{ dataSource, columns, loading }}
        rowKey="key"
        scroll={{ x: 'auto' }}
        pagination
        summary={pageData => <TableSummary data={pageData} />}
    />
}

export default SatReportTable;